export default "https://cdn.questicon.mathletics.com/assets/audio/selfAssesmentEmojis_3-549b011be7f6b4b1ef3319a3fe44f7c5.mp3";